import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WordpressService } from '../services/wordpress.service';
@Component({
  selector: 'app-active',
  templateUrl: './active.component.html',
  styleUrls: ['./active.component.css']
})
export class ActiveComponent implements OnInit, OnChanges {
  public imagen: string;
  public content: string;
  constructor(  private route: ActivatedRoute, private wordpressService: WordpressService) { }

  @Input() result;

  ngOnInit() {
    const id = this.route.snapshot.queryParams['id'];

    this.wordpressService.getSurveysByID(id).subscribe(
      data => {
        this.result = JSON.parse(data._body);
        this.content = this.result ? this.result.content.rendered : '';
      }
    );
  //   this.route.params.subscribe(params => {
  //     this.result = params['input']; // (+) converts string 'id' to a number

  //     // In a real app: dispatch action to load the details here.
  //  });

  }

  ngOnChanges(): void {
    this.content = this.result ? this.result.excerpt.rendered : '';
    const fromStr = this.result ? this.result.content.rendered.indexOf('/>') : '';
    this.imagen =  this.result ? `${this.result.content.rendered.substr(0, fromStr + 3)}` : '';
  }

}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/active/active.component.ts